export interface StatusPagamentoModel {
    name: string;
    descricao: string;
}

export const statusPagamento: StatusPagamentoModel[] = [
    { name: 'NEGADO_POR_AUTORIZADOR', descricao: 'Negado pelo autorizador' },
    { name: 'CONFIRMADO', descricao: 'Confirmado' },
    { name: 'CANCELADO', descricao: 'Cancelado' },
    { name: 'CANCELADO_POR_FALHA', descricao: 'Cancelador por falha' },
    { name: 'AUTORIZADO', descricao: 'Autorizado' },
    { name: 'AGUARDANDO_ATUALIZACAO', descricao: 'Aguardando atualização' },
];